import React from 'react';
import PropTypes from 'prop-types';

export const activationDescriptionId = 'remote-access-activation-description';

function Content({ email }) {
  return (
    <div id={activationDescriptionId} className="remote-access-dialog__text">
      A confirmation email has been sent to {email}. Click on the link in the email to activate your remote access.
    </div>
  );
}

Content.defaultProps = {
  email: '',
};

Content.propTypes = {
  email: PropTypes.string,
};

export default Content;
